export default "__VITE_ASSET__D9McRJ31__"